import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import {Cross} from './Icons';
import {tabletWidth} from '../mixins';

const modalRoot = document.getElementById('modal');

const StyledModal = styled(Modal)`
    z-index: 1800;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 24px rgba(58, 79, 79, 0.12);
    
    >div {
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    
    div.modal-header {
      border: none !important;
      padding: 20px 32px 0 !important;
    }
    
  
    div.modal-footer{
      border: none !important;
      justify-content: space-between !important;
    }

    div.modal-content {
      width: 100%;
      min-height: 180px;
      height: auto;
      background: #FFFFFF;
      border: none;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 24px rgba(58, 79, 79, 0.12);
      border-radius: 32px;
      
      @media screen and (max-width: ${tabletWidth}) {
        width: 95%;
        margin: 0 auto;
      }
    }
`;

const StyledCloseBtn = styled.button`
  background-color: transparent;
  border: none;
  padding: 5px;
  position: absolute;
  top: 23px;
  right: 20px;
  z-index: 1000;

`;

const StyledCancel = styled.button`
  width: auto;
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #848484;
  background-color: transparent;
  border-radius: 24px;
  color: #848484;
`;

const StyledActionBtn = styled(StyledCancel)`
  padding: 10px 32px;
  background: #00BFA5;
  color: #fff;
  border: 1px solid #00BFA5;
  margin-left: auto;
`;

const ModalPopup = ({show, body, btnText, onCloseClick, onActionClick, hideCancelOption, hideButtons, hideHeader, hideClose}) => {
    return ReactDOM.createPortal(
        <StyledModal show={show} onHide={onCloseClick} aria-labelledby="contained-modal-title-vcenter" centered>
            {!hideClose && <StyledCloseBtn onClick={onCloseClick}>{Cross}</StyledCloseBtn>}
            <Modal.Body>
                {body}
            </Modal.Body>

            {!hideButtons && (<Modal.Footer>
                {!hideCancelOption && <StyledCancel onClick={onCloseClick}>Cancel</StyledCancel>}
                <StyledActionBtn onClick={onActionClick}>{btnText}</StyledActionBtn>
            </Modal.Footer>)}

        </StyledModal>
        ,
        modalRoot
    );

};


export default ModalPopup;